import { useFormik } from 'formik'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useIsMobileView } from '../hooks/useIsMobileView'
import { useRequests } from '../requests/useRequests'
import { RefreshActions } from '../state/refresh'
import { State } from '../types/state'
import Button from '@mui/material/Button'
import { useParams } from 'react-router'
import { Index, IndexRequirementType } from '../types/subject'
import Fab from '@mui/material/Fab'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { InputLabel, Select, MenuItem, FormControl } from '@mui/material'

export const SubjectRequirements = () => {
  const { subjectId } = useParams()
  const dispatch = useDispatch()
  const isMobileView = useIsMobileView()
  const requestMaker = useRequests()
  const userState = useSelector((state: State) => state.user)
  const { subjects, app } = userState
  const subject = subjects.find(s => s.id === Number(subjectId))

  const validate = (requirements: {
    indexes: Index[]
  }): { indexes: Index[] } => {
    const errors: typeof requirements = {} as any

    // validateUsername(user.username ?? null, e => (errors.username = e))
    // validateMail(user.email ?? null, e => (errors.email = e))
    // validateName(user.firstName ?? null, e => (errors.firstName = e))
    // validateName(user.lastName ?? null, e => (errors.lastName = e))

    return errors
  }

  const onSubmit = useCallback(
    async (requirements: { indexes: Index[] }): Promise<void> => {
      try {
        const body = {
          subjectId: Number(subjectId),
          indexRequirements: requirements.indexes
            .map(i =>
              i.requirements.map(r => ({
                subjectId: Number(subjectId),
                indexId: r.indexId,
                requirement: r.requirement,
                id: undefined
              }))
            )
            .flat()
        }
        await requestMaker.updateSubjectIndexRequirements(body)
        dispatch(
          RefreshActions.setToastMessage({
            message: 'Succesfully updated index requirements'
          })
        )
        dispatch(RefreshActions.refreshUserState())
      } catch (e) {
        dispatch(
          RefreshActions.setToastMessage({
            message:
              'Error - fill all neccessary fields correctly and try again'
          })
        )
      }
    },
    [requestMaker, dispatch]
  )

  const formik = useFormik({
    initialValues: {
      indexes: subject?.indexes ?? []
    },
    onSubmit,
    enableReinitialize: true,
    validate
  })

  const subjectsToSelectNumber =
    (app?.highLevelSubjectNumber ?? 0) + (app?.standardLevelSubjectNumber ?? 0)

  return (
    <form>
      <div style={{ width: isMobileView ? '80vw' : '40vw', margin: 'auto' }}>
        <DialogTitle>{`Index Requirements - ${subject?.name}`}</DialogTitle>
        <DialogContent>
          {formik.values.indexes.map((index, i) => (
            <>
              <h2>{index.index}</h2>
              {index.requirements.map((r, ri) => (
                <>
                  <FormControl fullWidth style={{ marginTop: '1vw' }}>
                    <InputLabel id='role'>Type</InputLabel>
                    <Select
                      labelId='type'
                      id='type'
                      value={r.requirement.type}
                      label='Type'
                      required
                      onChange={e => {
                        if (!e.target.value) {
                          return
                        }
                        const currentIndexes = [...formik.values.indexes]
                        const currentIndex = { ...currentIndexes[i] }
                        const currentRequirements = [
                          ...currentIndex.requirements
                        ]
                        const currentRequirement = {
                          ...currentRequirements[ri]
                        }
                        const singleRequirement = {
                          ...currentRequirement.requirement
                        }
                        singleRequirement.type = e.target.value as any
                        currentRequirement.requirement = singleRequirement
                        currentRequirements[ri] = currentRequirement
                        currentIndex.requirements = currentRequirements
                        currentIndexes[i] = currentIndex
                        void formik.setFieldValue('indexes', currentIndexes)
                      }}
                    >
                      {Object.keys(IndexRequirementType)?.map((r, index) => (
                        <MenuItem key={index} value={r}>
                          {r}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {/* {r.requirement.type !== IndexRequirementType.REQUIRED && ( */}
                  <FormControl fullWidth style={{ marginTop: '1vw' }}>
                    <InputLabel id='subject'>Subject</InputLabel>
                    <Select
                      labelId='subject'
                      id='subject'
                      value={r.requirement.subjectId}
                      label='Subject'
                      required
                      onChange={e => {
                        if (!e.target.value) {
                          return
                        }
                        const currentIndexes = [...formik.values.indexes]
                        const currentIndex = { ...currentIndexes[i] }
                        const currentRequirements = [
                          ...currentIndex.requirements
                        ]
                        const currentRequirement = {
                          ...currentRequirements[ri]
                        }
                        const singleRequirement = {
                          ...currentRequirement.requirement
                        }
                        singleRequirement.subjectId = e.target.value as any
                        currentRequirement.requirement = singleRequirement
                        currentRequirements[ri] = currentRequirement
                        currentIndex.requirements = currentRequirements
                        currentIndexes[i] = currentIndex
                        void formik.setFieldValue('indexes', currentIndexes)
                      }}
                    >
                      {subjects?.map((r, index) => (
                        <MenuItem key={index} value={r.id}>
                          {r.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {/* )} */}
                  {/* {r.requirement.type !== IndexRequirementType.REQUIRED && ( */}
                  <FormControl fullWidth style={{ marginTop: '1vw' }}>
                    <InputLabel id='onIndex'>On Index</InputLabel>
                    <Select
                      labelId='index'
                      id='index'
                      required
                      value={r.requirement.index}
                      label='On Index'
                      onChange={e => {
                        if (!e.target.value) {
                          return
                        }
                        const currentIndexes = [...formik.values.indexes]
                        const currentIndex = { ...currentIndexes[i] }
                        const currentRequirements = [
                          ...currentIndex.requirements
                        ]
                        const currentRequirement = {
                          ...currentRequirements[ri]
                        }
                        const singleRequirement = {
                          ...currentRequirement.requirement
                        }
                        singleRequirement.index = e.target.value as any
                        currentRequirement.requirement = singleRequirement
                        currentRequirements[ri] = currentRequirement
                        currentIndex.requirements = currentRequirements
                        currentIndexes[i] = currentIndex
                        void formik.setFieldValue('indexes', currentIndexes)
                      }}
                    >
                      {Array.from({ length: subjectsToSelectNumber })?.map(
                        (_, i) => (
                          <MenuItem key={i + 1} value={i + 1}>
                            {i + 1}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                  {/* )} */}
                  <Fab
                    size='small'
                    onClick={() => {
                      const currentIndexes = [...formik.values.indexes]
                      const currentIndex = { ...currentIndexes[i] }
                      currentIndex.requirements =
                        currentIndex.requirements.filter(r2 => r2.id !== r.id)
                      currentIndexes[i] = currentIndex
                      void formik.setFieldValue('indexes', currentIndexes)
                    }}
                    color='error'
                    aria-label='delete'
                    style={{ transform: 'scale(0.8)' }}
                  >
                    <DeleteIcon />
                  </Fab>
                </>
              ))}
              <br />
              <Fab
                size='small'
                color='primary'
                aria-label='add'
                onClick={() => {
                  const currentIndexes = [...formik.values.indexes]
                  const currentIndex = { ...currentIndexes[i] }
                  currentIndex.requirements = [
                    ...currentIndex.requirements,
                    {
                      indexId: index.id!,
                      requirement: {}
                    }
                  ]
                  currentIndexes[i] = currentIndex
                  void formik.setFieldValue('indexes', currentIndexes)
                }}
                style={{ margin: '1vw' }}
              >
                <AddIcon />
              </Fab>
            </>
          ))}
        </DialogContent>
      </div>

      <DialogActions>
        <Button
          onClick={formik.handleSubmit as any}
          style={{ margin: 'auto' }}
          variant='contained'
        >
          Update
        </Button>
      </DialogActions>
    </form>
  )
}

export default SubjectRequirements
